// src/components/AuditStats.vue
<template>
  <b-container fluid>
    <!-- <div v-if="avgAuditAge > 0">
      Average age of open audits: {{ avgAuditAge }} days
    </div>
    <div v-if="avgResponseTime > 0">
      Average response time for completed audits: {{avgResponseTime}} days
    </div> -->
    <!-- <div>
      {{failedCounts}}
    </div> -->
    <br>
    <div class="search-box shadow form-row">
      <b-form-select v-model="selectedChart" :options="chartSelectDropDownOptions"> </b-form-select>
    </div>
    <div v-if=showCharts>
      <line-chart :chart-data="completionData" :options="chartOptions" :styles="chartStyles"></line-chart>
    </div>
    <div>
      <b-progress class="mt=2" :max="numAudits" show-value>
        <b-progress-bar variant="primary" :label=inprogressLbl :value=aggregateAudits.inprogress></b-progress-bar>
        <b-progress-bar variant="secondary" :label=inreviewLbl :value=aggregateAudits.inreview></b-progress-bar>
        <b-progress-bar variant="warning" :label=inreviewCompleteLbl :value=aggregateAudits.inreviewComplete></b-progress-bar>
        <b-progress-bar variant="success" :label=completeLbl :value=aggregateAudits.complete></b-progress-bar>
      </b-progress>
    </div>
  </b-container>
</template>

<script>
import LineChart from './AuditChart.vue'

export default {
  name: 'AuditStats',
  props: [
      'audits'
  ],
  data() {
    return {
      chartSelectDropDownOptions: [
        {value: null, text:'Please select a chart'},
        {value: 'completion', text:'Complete - Days from Audit Date to Complete'},
        {value: 'review', text:'In-Review - Days from Audit Date to In Review'},
        {value: 'review-complete', text:'Review Complete - Days from In Review to Review Complete'},
        {value: 'findings', text: 'Findings - Number of Failed Items'}
      ],
      selectedChart:null
    }
  },
  components: {
    "line-chart":LineChart
  },
  methods: {
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
  },
  computed: {
      aggregateAudits() {
          let counts = {
              inprogress:0,
              inreview:0,
              inreviewComplete:0,
              complete:0
          }
          if(this.audits) {
              this.audits.forEach((a) => {
                  if(a.state =="inprogress") counts.inprogress++
                  else if (a.state == "in-review") {
                    if(a.reviewState == "complete") {
                      counts.inreviewComplete++
                    } else {
                      counts.inreview++
                    }
                  }
                  else if(a.state == "complete") counts.complete++
              })
          }
          console.log("aggregatedAudits", counts, this.audits);
          return counts;
      },
      avgAuditAge() {
        let totalDaysOpen = 0;
        let today = new Date();
        let msInDays = 1000 * 60 * 60 * 24;
        let openAudits = this.audits.filter(a => a.state != "complete");
        if(openAudits.length > 0) {
          let totalAge = openAudits
            .map(a => Math.floor((today.getTime() - new Date(a.date))/msInDays) )
            .reduce((a, b) => a + b, 0);
          console.log("total age of audits", totalAge)
          totalDaysOpen = Math.floor(totalAge/openAudits.length);
        }
        return totalDaysOpen
      },
      avgResponseTime() {
        let total = 0;
        let msInDays = 1000 * 60 * 60 * 24;
        let completedAudits = this.completedAudits
        console.log("completed audits", completedAudits)
        completedAudits = completedAudits
          .filter(a => a.reviewCompleteDate && a.inReviewDate);
        console.log("completed audits", completedAudits)
        if(completedAudits.length > 0) {
          let totalTime = completedAudits
            .map(a => Math.floor((new Date(a.reviewCompleteDate) - new Date(a.inReviewDate))/msInDays) )
            .reduce((a,b) => a+b, 0)
          console.log("total response time of audits", totalTime)
          total = Math.floor(totalTime/completedAudits.length);
        }
        return total
      },
      failedCounts() {
        let byAudit = {}
        let completedAudits = this.audits.filter(a => a.state == "complete" || (a.state=="in-review"))
        console.log("completed audits 1", completedAudits)
        completedAudits = completedAudits.filter(a => a.failedReview != undefined)
        console.log("completed audits 2", completedAudits)
        if(completedAudits.length > 0) {
          byAudit = completedAudits.reduce((accumulator, value) => {
            if(!accumulator[value.facilityName]) {
              accumulator[value.facilityName] = [value]
            }
            accumulator[value.facilityName].push(value)
            console.log(value.facilityName, accumulator[value.facilityName].length)
            return accumulator
          }, {});
        }
        return byAudit
      },
      completedAudits() {
        let completed = [];
        if (this.audits) {
          completed = this.audits
            .filter(a => a.state == "complete" || (a.state =="in-review" && a.reviewState == "complete"))
            .filter(a => a.completeDate);        
        }
        return completed;
      },
      inReviewAudits() {
        let audits = [];
        if (this.audits) {
          audits = this.audits
            .filter(a => a.state == 'complete' || a.state == 'in-review')
            .filter(a => a.inReviewDate && (new Date(a.inReviewDate) > new Date(a.date)))
        }
        return audits;
      },
      reviewCompleteAudits() {
        let audits = [];
        if (this.audits) {
          audits = this.audits
            .filter(a => a.state == 'complete' || (a.state == 'in-review' && a.reviewState == "complete"))
            .filter(a => a.reviewCompleteDate && (new Date(a.reviewCompleteDate) > new Date(a.inReviewDate)))
        }
        return audits;
      },
      auditsWithFindings() {
        let audits = this.inReviewAudits;
        if (audits) {
          audits = this.audits
            .filter(a => a.failedReview != undefined)
        }
        return audits;
      },
      completionData() {
        let data;
        if (this.selectedChart == 'completion') {
          let completed = this.completedAudits;
          completed = sortAudits(completed)
          console.log("sorted audits", completed)
          if (completed) {
            let daysComplete = completed.map(f => {
                    let diff = new Date(f.completeDate) - new Date(f.date)
                    return Math.ceil(diff/(1000*60*60*24))
                  });
            data = calcChartData(completed.map(f => f.facilityName + ' ' +  f.date), daysComplete, 'Days to Complete')
          }
        } else if (this.selectedChart == 'review') {
          let audits = this.inReviewAudits;
          audits = sortAudits(audits)
          if (audits) {
            let daysInReview = audits.map(f => {
              let diff = new Date(f.inReviewDate) - new Date(f.date)
              return Math.ceil(diff/(1000*60*60*24))
            })
            data = calcChartData(audits.map(f => f.facilityName + ' ' + f.date), daysInReview, 'Days to in-review')
          }

        } else if (this.selectedChart == 'review-complete') {
          let audits = this.reviewCompleteAudits;
          audits = sortAudits(audits)
          console.log("audits are", audits)
          if (audits) {
            let daysInReview = audits.map(f => {
              let diff = new Date(f.inReviewCompleteDate) - new Date(f.inReviewDate)
              return Math.ceil(diff/(1000*60*60*24))
            })
            data = calcChartData(audits.map(f => f.facilityName + ' ' + f.date), daysInReview, 'Days spent in review')
          }
        } else if (this.selectedChart == 'findings') {
          let audits = this.auditsWithFindings;
          audits = sortAudits(audits)
          console.log("audits are", audits)
          if (audits) {
            let daysInReview = audits.map(f => f.failedReview)
            data = calcChartData(audits.map(f => f.facilityName + ' ' + f.date), daysInReview, 'Findings per audit')
          }
        }
        return data  
      },
      datacollection() {
        let failedCounts = this.failedCounts;
        let audit = failedCounts["Graph Test"]
        if(audit) {
          let data = {
            labels: audit.map(f => f.date),
            datasets: [
              {
                label: 'Galveston Bronch test',
                data: audit.map(f => f.failedReview)
              }
            ]
          }
          console.log("chart data is", data)
          return data;        
        }
        
      },
      chartStyles() {
        return {
          positition: 'relative'
        }
      },
      chartOptions() {
        return {
          scales: {
            yAxes: [
              {
                ticks: {beginAtZero: true}
              }
            ]
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      },
      numAudits() {
        return this.aggregateAudits.inprogress + this.aggregateAudits.inreview + this.aggregateAudits.inreviewComplete + this.aggregateAudits.complete
      },
      inprogressLbl() {
        return "In Progress: " + this.aggregateAudits.inprogress;
      },
      inreviewLbl() {
        return "In Review: " + this.aggregateAudits.inreview;
      },
      inreviewCompleteLbl() {
        return "Review Complete: " + this.aggregateAudits.inreviewComplete;
      },
      completeLbl() {
        return "Complete: " + this.aggregateAudits.complete;
      },
      showCharts() {
        return this.selectedChart && this.numAudits > 0
      }

  },
}
/**
 * Create data for a chart
 */
function calcChartData(dataLabels, data, seriesLabel) {
  let mov_avg = movingAvg(data, 3); 
  let chartData = {
    labels: dataLabels,
    datasets: [
      {
        type:'line',
        label: 'Moving Average',
        data: mov_avg,
        backgroundColor: '#fd9a6c',
        borderColor: '#fd9a6c',
        fill: false,
      },
      {
        type:'bar',
        label: seriesLabel,
        data: data,
        backgroundColor: '#56c05e',
        borderColor: '#56c05e',
        fill:'false'
      },
    ]
  }
  console.log("chart data is", data)
  return chartData; 

}
function movingAvg(data, count) {
  let result = [];
  console.log("MA", data, count)
  for(let i = 0; i < data.length; ++i) {
    if(i < count) {
      result.push(undefined);
      continue;
    }
    let sub = data.slice(i - count, i);
    let avg = sub.reduce((a,b) => a+b, 0)/count;
    result.push(avg)
  }
  return result;
}
function sortAudits(audits) {
  return audits.sort((a, b) => new Date(a.date) - new Date(b.date) )
}
</script>

<style>
.chart-container {
  flex-grow: 1;
  min-height: 0;
}
.chart-container .div {
  position: relative;
  height: 100%;
}
</style>